import { render, staticRenderFns } from "./babySubmitBtn.vue?vue&type=template&id=ff6a18ec&scoped=true&"
import script from "./babySubmitBtn.vue?vue&type=script&lang=js&"
export * from "./babySubmitBtn.vue?vue&type=script&lang=js&"
import style0 from "./babySubmitBtn.vue?vue&type=style&index=0&id=ff6a18ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6a18ec",
  null
  
)

export default component.exports